const FEE_RATE = 0.029; // 2.9%
const FEE_FIXED = 0.3; // $0.30

function calculateFees(amount) {
  const fees = Math.round((amount * FEE_RATE + FEE_FIXED) * 100) / 100;
  return fees;
}

function calculateTotal(amount, coverFees) {
  if (!coverFees) return amount;
  return Math.round((amount + calculateFees(amount)) * 100) / 100;
}

module.exports = {
  FEE_RATE,
  FEE_FIXED,
  calculateFees,
  calculateTotal,
};
